<template lang="html">
    <div class="card is-fullwidth">
        <div class="card-image">
   
  </div>
        <div class="card-content">
            <a class="card-avatar">
                <img :src="user.avatar" class="card-avatar-img">
            </a>

            <div class="card-user">
                <div class="card-user-name">
                    {{ user.name }} {{ user.last_name }}
                </div>
                <span>
                    <a :href="'mailto:' + user.email">{{ user.email }}</a>
                </span>
                <p>
                    {{ user.role | role }}
                </p>
            </div>
            <p>
                <small>
                    Departamento
                    <strong v-if="user.department">
                        {{ user.department.name }}
                    </strong>
                    <strong v-else>
                        No asignado
                    </strong>
                </small>
            </p>
            <p>
                <small>
                    Sucursal
                    <strong v-if="user.branch_office">
                        {{ user.branch_office.name }}
                    </strong>
                    <strong v-else>
                        No asignado
                    </strong>
                </small>
            </p>
            <p>
                <small>
                    Checkpoints
                    <strong v-if="user.checkpoints">
                        {{ user.checkpoints.length }}
                    </strong>
                    <strong v-else>
                        0
                    </strong>
                </small>
            </p>
            <small>
                Ultima modificación  {{ user.updated_at | date }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            required: true,
            type: Object,
        }
    }
}
</script>

<style lang="css">
</style>
